import { MenuItem } from '@mui/material';
import UploadRegulationDialog from 'components/Dialog/UploadRegulationDialog/UploadRegulationDialog';
import { useAuthDispatch } from 'contexts/auth/useAuth';
import { IInspection, StatusEnum } from 'pages/SchedulerList/components/Inspection/Inspection.types';
import React, { useState } from 'react';
import InspectionService from 'services/ApiService/InspectionService/inspectionService';
import InspectionPlatformService from 'services/InspectionPlatformService/inspectionPlatformService';

interface IUploadRegulationMenuItemProps {
  inspection: IInspection;
}

const UploadRegulationMenuItem = ({ inspection }: IUploadRegulationMenuItemProps) => {
  const [isUploadRegulationDialogOpen, setIsUploadRegulationDialogOpen] = useState(false);
  const { isRegulator, isAdmin, isInsuranceCompany } = useAuthDispatch();

  const hasPermition = isRegulator() || isAdmin() || isInsuranceCompany();

  const isTransmition = InspectionPlatformService.isSORTInspection(inspection.inspectionPlatform?.code);

  const showIfIsDigital = isTransmition
    ? inspection.currentStatus?.type === StatusEnum.PHOTO_RECEIVED
    : inspection.currentStatus?.type === StatusEnum.PHOTO_RECEIVED ||
      inspection.currentStatus?.type === StatusEnum.INSPECTION_STARTED ||
      inspection.currentStatus?.type === StatusEnum.LINK_SENT;

  const showIfIsLocally =
    InspectionService.isInspectionCategoryLocally(inspection?.inspectionCategory) &&
    inspection.currentStatus?.type === StatusEnum.DEFAULT;

  const showByPermissionAndCurrentStatus = hasPermition && (showIfIsDigital || showIfIsLocally);

  return (
    <>
      <MenuItem
        data-testid="upload-regulation"
        onClick={() => setIsUploadRegulationDialogOpen(true)}
        disabled={!showByPermissionAndCurrentStatus}
      >
        Enviar Arquivos de Regulação
      </MenuItem>

      <UploadRegulationDialog
        dialogVisibility={isUploadRegulationDialogOpen}
        inspection={inspection}
        handleClose={() => setIsUploadRegulationDialogOpen(false)}
      />
    </>
  );
};

export default UploadRegulationMenuItem;
